import React, { memo } from 'react';
import theme from "../../../theme";

type Props = {
    children: React.ReactNode,
};

const DialogHeader: React.FC<Props> = ({ children }) => {
    const styles = ({
        fontSize: '20px',
        fontWeight: theme.fonts.weights.base,
        fontFamily: theme.fonts.frutiger,
        color: theme.colours.grey[900],
        marginBottom: "12px",
    });
    return (
        <h2 css={styles}>{children}</h2>
    );
};

export default memo(DialogHeader);
